/** Internal dependencies */
import whenDocumentReady from './utilities/whenDocumentReady';
import { replaceContent } from './frontendhbs/replaceContent';
import { loadAjax } from './frontendhbs/loadAjax';
import { loadHbstmpl } from './frontendhbs/loadHbstmpl';
import { resetPagination } from './frontendhbs/resetPagination';
import { getCurrentFilters } from './frontendhbs/getCurrentFilters';
import { apiCall } from './frontendhbs/apiCall';
import { populateFiltersFromUrl } from './frontendhbs/populateFiltersFromUrl';
import { whenJqueryAvailable } from './utilities';

// Initialize the script as soon as the document is loaded
whenDocumentReady(initRest);

function initRest() {
    // dynamic ajax content replacer
    const restCallsReplace = document.querySelectorAll('[data-ct-rest-replace]');
    if (restCallsReplace) {
        // If there are any `[data-ct-rest-replace]` elements, loop over all of them and run the `replaceContent` function
        restCallsReplace.forEach((parent) => replaceContent(parent));
    }

    // rest ajax loader
    const restCalls = document.querySelectorAll('[data-ct-rest]');
    if (restCalls) {
        // If there are `[data-ct-rest]` elements, loop over all of them and run the `loadAjax` function
        restCalls.forEach((parent) => loadAjax(parent));
    }

    // handlebars template
    const tmpl = document.querySelectorAll('.hbstmpl');
    if (tmpl) {
        // if there are `.hbstmpl` elements, loop over them and run `loadHbstmpl`.
        tmpl.forEach((element) => loadHbstmpl(element));
    }
}

window.filterForm = (filterClass) => {
    const filterContainers = document.querySelectorAll(`.${filterClass}`);

    if (filterContainers) {
        filterContainers.forEach((filterContainer) => {
            const parent = filterContainer.closest('[data-ct-rest]');
            if (parent) {
                resetPagination(parent);
                const currentFilters = getCurrentFilters(parent);
                apiCall(parent, currentFilters, true);
            }
        });
    }
};

if (Boolean(document.querySelector('.wsf-form'))) {
    // wait for jQuery to be available in the global scope
    whenJqueryAvailable(initializeWsForms);
}

function initializeWsForms() {
    jQuery(function ($) {
        // check existing forms maybe already rendered
        const renderedForms = document.querySelectorAll('.wsf-form[data-wsf-rendered]');
        if (renderedForms) {
            renderedForms.forEach((form) => {
                if (!form.dataset.ctWsFormFhbsInitialized) {
                    const { id } = form.dataset;
                    initWsForm(id);
                }
            });
        }

        // other forms will emit the wsf-rendered event once they're ready
        $(document).on('wsf-rendered', function (e, form, form_id, instance_id) {
            const wsForm = document.querySelector(`.wsf-form[data-id="${form_id}"]`);
            if (!wsForm.dataset.ctWsFormFhbsInitialized) {
                initWsForm(form_id);
            }
        });
    });
}

function initWsForm(id) {
    const wsForm = document.querySelector(`.wsf-form[data-id="${id}"]`);
    const parent = wsForm.closest('[data-ct-rest]');

    if (parent) {
        populateFiltersFromUrl(parent);

        // check for and update possible select2 instances
        const select2s = wsForm.querySelectorAll('[class*="ct-filter-"][data-wsf-select2]');
        if (select2s) {
            select2s.forEach((select2El) => {
                jQuery(select2El).select2();
            });
        }
    }

    const formFilterRefreshs = document.querySelectorAll(`.wsf-form[data-id="${id}"] .filter-refresh`);
    if (!formFilterRefreshs) {
        return;
    }

    formFilterRefreshs.forEach((filterRefresh) => {
        filterRefresh.addEventListener('change', handleFilterRefreshChange);
    });

    wsForm.setAttribute('data-ct-ws-form-fhbs-initialized', 'true');
}

function handleFilterRefreshChange(e) {
    const filterRefresh = e.currentTarget;
    if (filterRefresh.checked) {
        const parent = filterRefresh.closest('[data-ct-rest]');
        if (parent) {
            resetPagination(parent);
            const currentFilters = getCurrentFilters(parent);
            apiCall(parent, currentFilters, true);
        }
    }
}
